export const EMPTY_STATS = {
  total: 0, autoEvaluationDone: 0, evaluationDirecteurDone: 0, autoEvaluationPending: 0,
  faible: 0, aAmeliorer: 0, satisfaisant: 0, superieur: 0, exceptionnel: 0,
};

export function adaptTeamResponse(response) {
  return {
    rows: response.data.map((row) => ({
      ...row,
      ...Object.fromEntries(["section_1", "section_2", "section_3", "section_4", "note_generale_sections", "NOTE_GENERALE", "NOTE_MAXI"]
        .map((key) => [key, row[key] == null ? null : Number(row[key])])),
      evaluation_date: row.DATE_EVALUATION,
    })),
    stats: { ...EMPTY_STATS, ...response.stats },
    directions: (response.directions || []).map((row) => ({
      directionId: row.direction_id, directionCode: row.direction_code,
      nbrpersonne: Number(row.nbrpersonne), nbrevaluation: Number(row.nbrevaluation),
      finievaluation: Number(row.finievaluation),
      autoEvaluationPending: Math.max(0, Number(row.nbrpersonne) - Number(row.nbrevaluation)),
    })),
    filters: response.filters || { directions: [], services: [] },
    total: response.pagination.total,
  };
}
